import React from "react";

const OPTIONS = [
  { key: "", label: "Everyone" },
  { key: "incomplete", label: "Missing any step" },
  { key: "not_started", label: "Not signed in or no password" },
];

// One-tap "Not finished onboarding" chips on the Employees page, with how many people each would show.
export function OnboardingFilter({ value, onChange, counts }) {
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid="onboarding-filter">
      <span className="label-mono mr-1">Not finished onboarding</span>
      {OPTIONS.map(({ key, label }) => {
        const on = value === key;
        const n = key ? counts?.[key] : null;
        return (
          <button key={key || "all"} type="button" aria-pressed={on} onClick={() => onChange(key)}
            data-testid={`onboarding-filter-${key || "all"}`}
            className={`border border-black px-2.5 py-1 text-[10px] uppercase tracking-widest transition-colors duration-100 ${on ? "bg-black text-white" : "bg-white hover:bg-zinc-100"}`}>
            {label}
            {n != null && (
              <span data-testid={`onboarding-filter-count-${key}`}
                className={`ml-1.5 inline-block min-w-[18px] px-1 text-center ${on ? "bg-white text-black" : "bg-amber-300 text-black"}`}>
                {n}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
